import React from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';
import {Link} from 'react-router-dom';
import {generateRoutePath} from '@epic-core/common';
import styled from 'styled-components';

export const StyledLinks = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    a.btn-link {
        width: fit-content;
    }
    .studio-section-header {
        text-align: center;
    }
`;

export default class Contact extends React.Component {
    static propTypes = {
        contactData: PropTypes.object
    };

    state = {
        isVisible: false
    };

    onSlideIn = (isVisible) => {
        if (isVisible && !this.state.isVisible) {
            this.setState({isVisible: true});
        }
    };

    render() {
        const {contactData} = this.props;
        const {
            subTitle,
            title,
            buttonLabel,
            buttonHref,
            linkHref,
            linkLabel,
            eeoHref,
            eeoLabel,
            recruitHref,
            recruitLabel,
            formHref,
            formLabel,
            link2Href,
            link2Label
        } = contactData;
        return (
            <VisibilitySensor
                onChange={this.onSlideIn}
                partialVisibility
                scrollCheck={true}
                scrollDelay={10}>
                <section
                    className={`careers-contact ${this.state.isVisible ? 'runAnimation' : ''}`}>
                    <div className="studio-section-header">
                        <h1>{title}</h1>
                        {subTitle && <p>{subTitle}</p>}

                        {buttonHref && buttonLabel && (
                            <Link
                                className="ue-cta-button button-lg button-hover"
                                to={generateRoutePath(buttonHref)}>
                                {buttonLabel}
                            </Link>
                        )}
                        <StyledLinks>
                            {formHref && formLabel && (
                                <Link className="btn-link" to={generateRoutePath(formHref)}>
                                    {formLabel}
                                </Link>
                            )}
                            {linkHref && linkLabel && (
                                <Link className="btn-link" to={generateRoutePath(linkHref)}>
                                    {linkLabel}
                                </Link>
                            )}
                            {eeoHref && eeoLabel && (
                                <Link className="btn-link" to={generateRoutePath(eeoHref)}>
                                    {eeoLabel}
                                </Link>
                            )}

                            {link2Href && link2Label && (
                                <Link className="btn-link" to={generateRoutePath(link2Href)}>
                                    {link2Label}
                                </Link>
                            )}

                            {recruitHref && recruitLabel && (
                                <Link className="btn-link" to={generateRoutePath(recruitHref)}>
                                    {recruitLabel}
                                </Link>
                            )}
                        </StyledLinks>
                    </div>
                </section>
            </VisibilitySensor>
        );
    }
}
